module.exports = __webpack_public_path__ + "static/img/sjjc.10a12e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjjc.png
// module id = 2aKy
// module chunks = 1